import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import { isOptionAllowed } from '../../../shared/utils';
import { FIRST_SECOND_CONTACT, ROLES, casesAllowedList } from '../../../helper/constants';

class SidebarContent extends Component {
  static propTypes = {
    // changeToDark: PropTypes.func.isRequired,
    // changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };

  render() {
    return (
      <div className="sidebar__content">
        <ul className="sidebar__block">
          <div>
            <SidebarLink
              visible={isOptionAllowed(['admin', 'admin-port', ROLES.auditor])}
              title="Mi panel"
              icon="lnr lnr-chart-bars"
              route="/mipanel"
              onClick={this.hideSidebar}
            />
            <SidebarLink
              visible={isOptionAllowed(casesAllowedList)}
              title="Casos y tareas"
              icon="lnr lnr-inbox"
              route="/casos"
              onClick={this.hideSidebar}
            />
            <SidebarLink
              visible={isOptionAllowed(['admin', 'manager', 'sales-executive', ROLES.auditor, ...FIRST_SECOND_CONTACT])}
              title="Cotizaciones"
              icon="lnr lnr-license"
              route="/cotizaciones"
              onClick={this.hideSidebar}
            />
            <SidebarLink title="Contactos" icon="lnr lnr-user" route="/contactos" onClick={this.hideSidebar} />
          </div>
          <div>
            <SidebarLink
              visible={isOptionAllowed(['admin', 'admin-port', ROLES.auditor])}
              title="Usuarios y roles"
              icon="lnr lnr-users"
              route="/usuarios"
              onClick={this.hideSidebar}
            />
            <SidebarLink
              visible={isOptionAllowed(['admin', 'admin-port', 'manager', ROLES.auditor])}
              title="Tipificación"
              icon="lnr lnr-indent-increase"
              route="/tipificacion"
              onClick={this.hideSidebar}
            />
            <SidebarLink
              visible={isOptionAllowed(['admin', 'admin-port', 'manager'])}
              title="Administración"
              icon="lnr lnr-cog"
              route="/configuracion"
              onClick={this.hideSidebar}
            />
            <SidebarLink
              visible={isOptionAllowed(['admin', 'admin-port', 'manager', ROLES.auditor])}
              title="Plantillas"
              icon="lnr lnr-file-add"
              route="/templates"
              onClick={this.hideSidebar}
            />
          </div>
        </ul>
      </div>
    );
  }
}

export default SidebarContent;
